import styled from 'styled-components';
import { IFrame } from './interface';

const templateAreaForGlobalActive = `
'accounts accounts detailedAccounts detailedAccounts'
'result result faresNotReceived faresProvider'
'income income lastTwelveMonths lastTwelveMonths'
'table table table table'
`;

const templateAreaForGlobalActiveNotebook = `
'accounts accounts detailedAccounts detailedAccounts'
'result result faresNotReceived faresProvider'
'income income lastTwelveMonths lastTwelveMonths'
'table table table table'
`;

const templateAreaForGlobalInactive = `
  'accounts accounts detailedAccounts detailedAccounts'
  'faresReceived faresPassedOn faresNotReceived faresProvider'
  'income income lastTwelveMonths lastTwelveMonths'
`;

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'grid' : 'none')};
  grid-template-columns: ${(props) =>
    props.globalIsActive ? 'repeat(4, 1fr)' : 'repeat(4, 1fr)'};
  grid-template-rows: ${(props) =>
    props.globalIsActive ? 'repeat(3, 1fr)' : 'repeat(3, 1fr)'};
  grid-template-areas: ${(props) =>
    props.globalIsActive
      ? templateAreaForGlobalActiveNotebook
      : templateAreaForGlobalInactive};
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-columns: ${(props) =>
      props.globalIsActive ? 'repeat(4, 1fr)' : 'repeat(4, 1fr)'};
    grid-template-areas: ${(props) =>
      props.globalIsActive
        ? templateAreaForGlobalActive
        : templateAreaForGlobalInactive};
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
